<template>
  <section class="terms">
    <div>
      <h2>【「保険スクエアbang! 火災保険」ご利用に関するご注意】</h2>
      <ul>
        <li>
          株式会社ウェブクルーが運営する「保険スクエアbang!
          火災保険」（以下、当サイト）では、火災保険の見積もり・診断を依頼することができます。
        </li>
        <li>
          株式会社ウェブクルーは火災保険の媒介・募集・販売行為は行いません。
        </li>
        <li>
          下記に記載のある保険取扱代理店は、損害保険会社と代理店委託契約を締結し、当サイトなど株式会社ウェブクルーが運営するサイトに参加の上、損害保険の募集行為及び保険契約締結の代理または媒介を行っております。
        </li>
        <li>
          「共済をご希望の方はこちら（こくみん共済 coop サイト）」遷移先は、こくみん共済 coop （住まいる共済）のページです。
        </li>
        <li>
          「賃貸物件の方はこちら（外部サイト）」遷移先は、日新火災海上保険株式会社のページです。
        </li>
        <li>
          保険取扱代理店または損害保険会社が火災保険で推奨する保険商品をご案内いたします。<br />
          見積もり・診断の条件によっては保険会社1社のみのご案内となる場合がございます。予めご了承ください。
        </li>
        <li>
          当サイトにご入力いただいたお客様の情報は、<a
            href="javascript:void(0);"
            @click="$popUp.termWin()"
            >[利用規約]</a
          >に定める利用目的にて利用させていただきます。
        </li>
        <li>
          見積もり・診断結果及びその後のご案内は、保険取扱代理店または損害保険会社より、メール、お電話、郵送などにてご案内いたします。<br />なお、ご案内の際に診断ができない等、お断りさせていただく場合もございます。
        </li>
        <li>
          正確な見積もり・診断結果提示のために、さらに物件情報や補償内容についての詳しい情報をお伺いする場合がございます。
        </li>
        <li>
          架空の個人情報（氏名、電話番号、メールアドレス）を入力することは、詐欺行為に該当する悪質な犯罪行為です。
        </li>
      </ul>

      <h3>【診断できない条件について】</h3>
      <ul>
        <li>
          住宅金融支援機構の融資を受けていて、住宅金融支援機構特約火災保険に加入中の建物
        </li>
        <li>住居と併用していない店舗・事務所等の建物および家財</li>
        <li>賃貸借契約の建物</li>
      </ul>
      
      <h3>【保険取扱代理店】</h3>
      <ul v-if="campaignLpDisplay" class="tableList">
        <li>株式会社損害保険見直し本舗</li>
      </ul>
      <ul v-else class="tableList">
        <li v-for="(item, index) in fetchInsuranceAgentList" :key="index">
          {{ item }}
        </li>
      </ul>
      
      <h3>【引受保険会社】</h3>
      <ul class="tableList">
        <li>楽天損害保険株式会社</li>
        <li>東京海上日動火災保険株式会社</li>
        <li>AIG損害保険株式会社</li>
        <li>あいおいニッセイ同和損害保険株式会社</li>
        <li>損害保険ジャパン株式会社</li>
        <li>三井住友海上火災保険株式会社</li>
        <li>日新火災海上保険株式会社&nbsp;&nbsp;等</li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useFetcCmsElements } from "@/composables/useFetchCmsElements";

const props = defineProps({
  campaignLpDisplay: { type: Boolean, default: false }
});

const { fetchInsuranceAgentList } = useFetcCmsElements();
</script>

<style lang="scss" scoped>
/*---------------------------------------
.terms
----------------------------------------*/
.terms {
  background-color: #f8f7f3;

  > div {
    padding: 4%;

    h2,
    h3 {
      margin: 0 0 0.5em;
      font-size: px(12);
      font-weight: 700;
    }

    ul:not(:last-of-type) {
      margin: 0 0 1.5em;
    }

    li {
      padding: 0 0 0 0.7em;
      font-size: px(12);
      background: url(~/assets/images/list_dot.png) no-repeat left 0.7em;
      background-size: 4px auto;
      line-height: 1.74;

      a {
        color: #148cde;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

#promo {
  .terms {
    border-bottom: 1px solid #aec4d0;
    background-color: #e9f0f5;

    > div {
      padding: 4%;
      font-size: px(12.4);

      h2,
      h3 {
        margin-bottom: 3%;
        color: #666;
        font-size: px(17);
        font-weight: bold;
      }

      ul {
        margin-bottom: 8%;
      }

      li {
        margin-bottom: 1.5%;
        padding-left: 3%;
        color: #666;
        font-size: px(17);
        background: url(~/assets/images/promo/landing/list_dot.png) no-repeat
          left 0.6em;
        background-size: 4px auto;
        line-height: 1.5;

        a {
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      h3 + span {
        margin-bottom: 4%;
        display: block;
        color: #666;
        font-size: px(17);
      }
    }

    .button {
      padding: 4% 0;
      font-size: px(15);
    }
  }

  &.pageIndex07 .terms{
    background-color: #FFF;
  }

  &.pageIndex02 .terms > div, &.pageIndex07 .terms >div {
    h2,
    h3 {
      margin: 0 0 2%;
      font-size: px(14.5);
    }

    padding: 6% 4% 7%;

    ul {
      margin-bottom: 4%;
    }

    li {
      margin: 0;
      padding-left: 3%;
      font-size: px(14.3);
      line-height: 1.7;
    }
  }

  &.outsource .terms {
    margin: 0 auto 8vw;
    width: 94%;
    border-bottom: none;
    background-color: #eaf7ff;

    > div {
      padding: 0;
      font-size: px(15);

      h2,
      h3 {
        margin: 0;
        color: #2e2e2e;
        font-size: 2.9vw;
        font-weight: 700;
        margin-bottom: 2vw;
      }

      ul {
        margin-bottom: 4vw;
      }

      li {
        margin: 0;
        padding-left: 1em;
        color: #2e2e2e;
        font-size: 2.7vw;
        background: url(~/assets/images/promo/landing/list_dot.png) no-repeat
          left 0.7em;
        background-size: 4px auto;
        line-height: 1.8;

        a {
          color: #2e2e2e;
          text-decoration: none;
        }
      }
    }
  }
}

@include media(pc) {
  /*---------------------------------------
  .terms
  ----------------------------------------*/

  .terms {
    padding: 48px 0 0;

    > div {
      margin: 0 auto;
      padding: 0 0 25px;
      width: $pcWrapWidth;

      h2,
      h3,
      ul {
        margin: 0 auto;
        width: $pcWrapWidth;
      }

      li {
        font-size: px(12.9);
        line-height: 1.92;
      }
    }
  }

  #promo {
    .terms {
      padding: 0;
      border-bottom: none;

      > div {
        padding: 48px 0 0;
        width: 920px;
        overflow: hidden;

        h2,
        h3 {
          margin-bottom: 1%;
          font-size: px(15);
        }

        ul {
          margin-bottom: 3.5%;
          width: 920px;
        }

        li {
          margin-bottom: 0.5%;
          padding-left: 1%;
          font-size: px(15);
        }
      }

      .button {
        padding: 5% 0;
      }
    }

    &.pageIndex02 .terms, &.pageIndex07 .terms {
      padding: 33px 0 0;

      > div {
        padding: 0;
        width: 860px;

        h2,
        h3 {
          margin: 0 0 5px;
          padding: 0;
        }

        ul {
          width: 100%;
          margin: 0 0 50px;
        }

        li {
          padding: 0 0 0 10px;
        }
      }

      .button {
        padding: 5% 0;
        width: auto;
      }

      > div .tableList {
        column-count: 3;
      }
    }

    &.outsource .terms {
      margin: 0 auto 40px;
      width: 650px;

      > div {
        width: auto;

        h2,
        h3 {
          width: auto;
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 10px;
        }

        ul {
          margin-bottom: 30px;
          width: auto;
        }

        li {
          padding-left: 1em;
          font-size: 12px;
          background: url(~/assets/images/promo/landing/list_dot.png) no-repeat
            left 0.7em;
          background-size: 4px auto;
        }
      }
    }
  }
}
</style>
